<template>
  <el-table-column
    prop="target_storage.name"
    sortable="custom"
    label="Átvevő Raktár"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.target_storage_name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'target_storage.name',
};
</script>
